class MiniCartUpsellsCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper, Pagination }) => {
      const swiperParams = {
        modules: [Pagination],
        slidesPerView: "auto",
        slidesPerGroup: 3,
        spaceBetween: 24,
        pagination: {
          clickable: true,
          enabled: true,
          el: ".swiper-pagination",
        },
        centerInsufficientSlides: true,
      };

      this.swiper = new Swiper(this, swiperParams);
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("mini-cart-upsells-carousel")) {
  customElements.define("mini-cart-upsells-carousel", MiniCartUpsellsCarousel);
}
